import { render, staticRenderFns } from "./CustomerCancelReasons.vue?vue&type=template&id=aef03c94&scoped=true&"
import script from "./CustomerCancelReasons.vue?vue&type=script&lang=js&"
export * from "./CustomerCancelReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef03c94",
  null
  
)

export default component.exports